import { Switch, Route } from 'react-router'
import { BaseRoute } from 'Components'
import { useRouteMatch } from 'react-router'

import List from './List'
import Detail from './Detail'
import New from './New'

export default ->

  { path } = useRouteMatch()

  <>
    <Switch>
      <Route path="#{path}/new"><New /></Route>
      <Route path="#{path}/:mrId"><Detail /></Route>
      <Route exact><List /></Route>
    </Switch>
  </>
